import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/SocialAuthRedirectUrl.graphql';
import { Query, QuerysocialAuthRedirectUrlArgs } from '../../__generated__/globalTypes';

export const useSocialAuthRedirectUrlQuery = (options?: QueryHookOptions<Query, QuerysocialAuthRedirectUrlArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerysocialAuthRedirectUrlArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useSocialAuthRedirectUrlLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerysocialAuthRedirectUrlArgs>
): QueryResult<Query, QuerysocialAuthRedirectUrlArgs> & {
  getSocialAuthRedirectUrl: LazyQueryExecFunction<Query, QuerysocialAuthRedirectUrlArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getSocialAuthRedirectUrl, result] = useLazyQuery<Query, QuerysocialAuthRedirectUrlArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getSocialAuthRedirectUrl, ...result };
};

export const useSocialAuthRedirectUrlPromiseQuery = () => {
  const client = useApolloClient();

  const getSocialAuthRedirectUrl = useCallback(
    (options?: Omit<QueryOptions<QuerysocialAuthRedirectUrlArgs, Query>, 'query'>) =>
      client.query<Query, QuerysocialAuthRedirectUrlArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getSocialAuthRedirectUrl };
};
// Suspense Query Hooks
export const useSocialAuthRedirectUrlSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerysocialAuthRedirectUrlArgs>
) => {
  const result = useSuspenseQuery<Query, QuerysocialAuthRedirectUrlArgs>(QUERY, {
    ...options
  });

  return result;
};
